package com.essntl.features.task.ui.alltasks

import com.essntl.features.client.domain.model.ClientModel
import com.essntl.features.itinerary.domain.model.ItineraryModel
import com.essntl.features.profile.domain.model.ProfileModel
import com.essntl.features.task.domain.model.TaskFilterOptions
import com.essntl.features.task.domain.model.TaskModel

interface AllTasksEvent {
    data class UpdateTaskStatus(
        val taskId: String,
        val status: TaskModel.Status,
    ) : AllTasksEvent

    data class LoadTasks(val refresh: Boolean = false) : AllTasksEvent
    data class EditClient(
        val client: ClientModel,
        val itinerary: ItineraryModel,
    ) : AllTasksEvent

    data class AddEditTask(val task: TaskModel) : AllTasksEvent
    data class FilterTasks(val filterOptions: TaskFilterOptions) : AllTasksEvent
    data class UpdateTaskOwner(
        val taskId: String,
        val owner: ProfileModel,
    ) : AllTasksEvent
}